export const brand = {
  name: 'Diamond Suites Ocala',
  phoneDisplay: '352-244-8352',
  phoneHref: 'tel:+13522448352',
  email: 'ashley@diamondsuitesocala.com',
  addressLine1: '7494 SW 60th Ave, Suite A',
  addressLine2: 'Ocala, FL 34476',
  mapUrl:
    'https://www.google.com/maps/search/?api=1&query=7494+SW+60th+Ave+Suite+A+Ocala+FL+34476',
  facebook: 'https://www.facebook.com/profile.php?id=61571729423656',
  instagram: 'https://www.instagram.com/diamondsuitesocala/',
}

export const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Suites', to: '/suites/' },
  { label: 'Professionals', to: '/directory/' },
  { label: 'About', to: '/about/' },
  { label: 'FAQs', to: '/faqs/' },
  { label: 'Contact', to: '/contact/' },
]

export type SocialLink = {
  label: string
  url: string
}

export type Professional = {
  suite: number
  name: string
  businessName?: string
  title: string
  bio?: string[]
  image?: string
  phone?: string
  email?: string
  bookingUrl?: string
  websiteUrl?: string
  socialLinks?: SocialLink[]
}

export const professionals: Professional[] = [
  {
    suite: 1,
    name: 'Rosa Borrell',
    title: 'Nail Technician',
    phone: '352-292-6177',
    image: 'rosa-borrell.webp',
    bio: [
      'Hi, my name is Rosa, some call me Chinah. I am new to the nail tech world as of December, but I have always been a nail girly. I love the feeling of when I have my nails done and I would love to spread that feeling to others.',
      'Whether natural nails, short classic Frenchies, or long and bold, let me be your nail tech. I am a mom and a wife, and I also work in the veterinary field. My goal is to help you feel beautiful and also be a listening ear if need be.',
      'I am Cuban American, so Spanish-speaking clients are welcome. Book with me and let’s make beautiful nails together.',
    ],
  },
  {
    suite: 3,
    name: 'Aubrey Novy',
    businessName: 'Glow and Grace Aesthetics, LLC',
    title: 'Licensed Esthetician',
    phone: '352-220-2007',
    image: 'aubrey-novy.webp',
    bio: [
      'My name is Aubrey Novy, and I own and founded Glow and Grace Aesthetics. I have over 19 years of experience as a licensed esthetician and am certified in electrolysis and laser hair removal. My expertise lies primarily in medical aesthetics, and I have been a certified HydraFacial specialist for over a decade.',
      'I am deeply passionate about this field and constantly strive to expand my knowledge. Recently, I became a certified acne specialist through Face Reality and a Skinbetter Science Master. My focus is on crafting personalized treatment plans to help clients achieve their skincare goals, with a primary emphasis on building confidence in your skin.',
      'At Glow and Grace, my mission is to enhance your natural beauty and ensure your skin radiates with a healthy glow. I am thrilled to continue this journey and look forward to helping you embrace your best skin.',
    ],
  },
  {
    suite: 5,
    name: 'Nicole Avila',
    title: 'Nail Technician',
  },
  {
    suite: 6,
    name: 'Candice Fearon',
    title: 'Hair Stylist',
    phone: '352-208-1625',
    image: 'candice-fearon.webp',
    bio: [
      'Hi, I’m Candice Fearon, a passionate hair artist for over 17 years and dedicated herbalist who believes in the perfect blend of creativity and natural beauty.',
      'My approach to work is all about variety and balance. I bring a colorful and dynamic flair to every project, ensuring each client receives a unique and personalized experience. I am a perfectionist and will always do my best to make your hair easy to do. I specialize in thin, fine hair, short hair, and bobs.',
      'I enjoy mixing nature and science to create a truly holistic healing experience. Romans 1:20.',
    ],
  },
  {
    suite: 7,
    name: 'Leanna Bigay',
    title: 'Hair Stylist',
  },
  {
    suite: 8,
    name: 'Ashley Lehnis & Brianna Reynolds',
    title: 'Spray Tan Technicians',
  },
]

export const suiteDirectory = Array.from({ length: 8 }, (_, index) => {
  const suite = index + 1
  return {
    suite,
    professional: professionals.find((person) => person.suite === suite),
  }
})

export const serviceTypes = [
  'Hair',
  'Barbering',
  'Nails',
  'Skincare / Esthetics',
  'Lashes / Brows',
  'Massage',
  'Makeup',
  'Wellness',
  'Other',
] as const

export const services = [
  { title: 'Hair & Color', description: 'Hair styling, cuts, color, and related independent services.' },
  { title: 'Barbering', description: 'Barbering and grooming services from independent professionals.' },
  { title: 'Nails', description: 'Manicures, nail artistry, and other nail-focused services.' },
  { title: 'Skincare & Esthetics', description: 'Personalized skincare and esthetics experiences.' },
  { title: 'Lashes & Brows', description: 'Lash and brow styling, shaping, and enhancement services.' },
  { title: 'Massage', description: 'Independent massage and bodywork services, when represented.' },
  { title: 'Makeup', description: 'Makeup artistry for everyday looks, events, and special occasions.' },
  { title: 'Tanning', description: 'Sunless tanning and related beauty services.' },
  { title: 'Beauty & Wellness', description: 'Other independent beauty or wellness specialties, which may include injectables when appropriately offered.' },
]

export const amenities = [
  'Private, customizable suites',
  'Expansive windows and natural light',
  'Individual keypad access',
  'High-speed Wi-Fi and utilities',
  'On-site laundry access',
  'Shared waiting area and coffee bar',
  'Common-area maintenance',
  'Convenient on-site parking',
]

export const faqs = [
  {
    question: 'What kinds of beauty services can I find at Diamond Suites Ocala?',
    answer:
      'Diamond Suites brings independent beauty and wellness professionals together under one roof. The mix may include hair, barbering, nails, skincare and esthetics, lashes and brows, massage, makeup, tanning, and other beauty or wellness specialties. Current services depend on the independent professionals operating from the location.',
  },
  {
    question: 'How do I book an appointment?',
    answer:
      'Each professional manages their own schedule. Visit the Professionals directory to find a provider and contact them directly.',
  },
  {
    question: 'Are walk-ins accepted?',
    answer:
      'Some professionals may accept walk-ins, but most work by appointment. Contact your provider before visiting to confirm availability.',
  },
  {
    question: 'Where are you located?',
    answer:
      'Diamond Suites Ocala is located at 7494 SW 60th Ave, Suite A, Ocala, Florida. Parking is available directly outside the building.',
  },
  {
    question: 'What makes Diamond Suites different from a traditional salon or spa?',
    answer:
      'Diamond Suites is a community of independent businesses. Clients receive private, personalized service and can find several specialties in one modern location.',
  },
  {
    question: 'Do you offer gift cards?',
    answer:
      'Each independent professional manages their own payments, packages, and gift cards. Please ask the provider you plan to visit.',
  },
  {
    question: 'Can I book multiple services during one visit?',
    answer:
      'Because several specialties share the same building, clients can contact individual providers to coordinate appointments for the same day.',
  },
  {
    question: 'How can a beauty professional join Diamond Suites Ocala?',
    answer:
      'The suites are currently leased. Qualified professionals can contact the Diamond Suites Ocala team for pre-approval and placement on the waitlist.',
  },
]

export const locations = [
  {
    name: 'Diamond Suites Downtown Ocala',
    address: '917 E Silver Springs Blvd, Ocala, FL 34470',
    phone: '352-244-8367',
    href: 'https://diamondsuitesdowntownocala.com/',
    logo: 'DiamondSuitesDowntownOcalaLogo.gif',
  },
  {
    name: 'Diamond Suites Ocala',
    address: '7494 SW 60th Ave, Suite A, Ocala, FL 34476',
    phone: '352-244-8352',
    href: '/',
    logo: 'DiamondSuitesOcalaLogo.gif',
  },
  {
    name: 'Diamond Suites Crystal River',
    address: '825 N Citrus Ave, Crystal River, FL 34428',
    phone: '352-244-8367',
    href: 'https://diamondsuitescrystalriver.com/',
    logo: 'DiamondSuitesCrystalRiverLogo.gif',
  },
]
